var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var IntegrationService = /** @class */ (function () {
    function IntegrationService(api) {
        var _this = this;
        this.getIntegrations = function (appId) {
            return _this.API.get("/integrations/".concat(appId && "?app=".concat(appId)));
        };
        this.createIntegration = function (integration) {
            return _this.API.post('/integrations', integration);
        };
        this.updateIntegration = function (integration) {
            return _this.API.put("/integrations/".concat(integration.id), __assign(__assign({}, integration), { base_url: integration.baseUrl }));
        };
        this.getIntegrationMethods = function (integrationId) {
            var url = "/integrations/".concat(integrationId, "/method");
            return _this.API.get(url);
        };
        this.runMethod = function (requestUrl, type, headers, body) {
            var url = '/integrations/proxy';
            return _this.API.post(url, {
                request_url: requestUrl,
                type: type,
                headers: headers,
                body: body,
            });
        };
        this.API = api;
    }
    IntegrationService.prototype.getIntegration = function (integrationId) {
        var url = "/integrations/".concat(integrationId);
        return this.API.get(url);
    };
    IntegrationService.prototype.deleteIntegration = function (integrationId) {
        var url = "/integrations/".concat(integrationId);
        return this.API.delete(url);
    };
    IntegrationService.prototype.createMethod = function (integrationId, method) {
        return this.API.post("/integrations/".concat(integrationId, "/method"), method);
    };
    IntegrationService.prototype.getMethod = function (integrationId, methodId) {
        var url = "/integrations/".concat(integrationId, "/method/").concat(methodId);
        return this.API.get(url);
    };
    IntegrationService.prototype.updateMethod = function (integrationId, methodId, method) {
        var url = "/integrations/".concat(integrationId, "/method/").concat(methodId);
        return this.API.put(url, method);
    };
    IntegrationService.prototype.deleteMethod = function (integrationId, methodId) {
        var url = "/integrations/".concat(integrationId, "/method/").concat(methodId);
        return this.API.delete(url);
    };
    return IntegrationService;
}());
export { IntegrationService };
